// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"834ef9cb","206":"0348c3ef","323":"83f710ac","754":"a3d43637"}[chunkId] + ".chunk.js";
};